// extracted by mini-css-extract-plugin
module.exports = {"views_badge":"case_study_views_views_badge__1Jp8_","icon":"case_study_views_icon__aprmg","count":"case_study_views_count__GwZIW"};